import { RuntimeException } from "@/types/errors";

export class Ok extends RuntimeException {
    private static readonly _status: number = 200;

    static get statusCode(): number {
        return Ok._status;
    }

    constructor( msg: string ) {
        super( msg, Ok._status );
    }
}

export class Accepted extends RuntimeException {
    private static readonly _status: number = 202;

    static get statusCode(): number {
        return Accepted._status;
    }

    constructor( msg: string ) {
        super( msg, Accepted._status );
    }
}

export class NoContent extends RuntimeException {
    private static readonly _status: number = 204;

    static get statusCode(): number {
        return NoContent._status;
    }

    constructor( msg: string ) {
        super( msg, NoContent._status );
    }
}

export class MultipleChoices extends RuntimeException {
    private static readonly _status: number = 300;

    static get statusCode(): number {
        return MultipleChoices._status;
    }

    constructor( msg: string ) {
        super( msg, MultipleChoices._status );
    }
}

export class ApiError extends RuntimeException {
    constructor( code: number, message: string ) {
        super( message, code );
    }
}

export class AuthenticationFailed extends RuntimeException {
    private static readonly _status: number = -1;

    static get statusCode(): number {
        return AuthenticationFailed._status;
    }

    constructor( msg: string ) {
        super( msg, AuthenticationFailed._status );
    }
}

export class BadRequest extends RuntimeException {
    static readonly _status: number = 400;

    static get statusCode(): number {
        return BadRequest._status;
    }

    constructor( msg: string | null | undefined ) {
        super( msg ?? 'BAD REQUEST', BadRequest._status );
    }
}

export class Unauthorized extends RuntimeException {
    private static readonly _status: number = 401;

    static get statusCode(): number {
        return Unauthorized._status;
    }

    constructor() {
        super( 'UNAUTHORIZED', Unauthorized._status );
    }
}

export class Forbidden extends RuntimeException {
    static readonly _status: number = 403;

    static get statusCode(): number {
        return Forbidden._status;
    }

    constructor() {
        super( 'FORBIDDEN', Forbidden._status );
    }
}

export class NotFound extends RuntimeException {
    static readonly _status: number = 404;

    static get statusCode(): number {
        return NotFound._status;
    }

    constructor() {
        super( 'NOT FOUND', NotFound._status );
    }
}

export class UnprocessableContent extends RuntimeException {
    static readonly _status: number = 422;

    static get statusCode(): number {
        return UnprocessableContent._status;
    }

    constructor( msg: string | null | undefined ) {
        super( msg ?? 'UNPROCESSABLE CONTENT', UnprocessableContent._status );
    }
}

export class InternalError extends RuntimeException {
    static readonly _status: number = 500;

    static get statusCode(): number {
        return InternalError._status;
    }

    constructor() {
        super( 'INTERNAL ERROR', InternalError._status );
    }
}